import '@wit-support/ui/theme.css';
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import ReactDOM from 'react-dom/client';
import { ToastProvider } from '@wit-support/ui';
import { App } from './app.js';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <App />
    <ToastProvider position="bottom-right" theme="light" richColors closeButton />
  </>,
);
